import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import "./featurelist1.css";
import "./pharmmed.css"
import Select from 'react-select';
import DeleteMedConfirmPopup from './DeleteMedConfirmPopup'
import LoadingOverlay from "react-loading-overlay";
import { useAlert } from 'react-alert'
import 'react-table-v6/react-table.css'
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import InfoPopup1 from "./InfoPopup1";
function PharmMedicine(props) {
  const alert = useAlert();
  const [infoData1, setInfoData1] = useState("");
  const [loading, setLoading] = useState(false);
  const [featureList, setFeatureList] = useState([]);
  const [searchTermMed, setSearchTermMed] = useState("");
  const [page, setPage] = useState(1);
  const [action, setAction] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [drugInt, setdrugInt] = useState(false);
  const [MedConfirmModalShow, setMedConfirmModalShow] = useState(false);
  const [id, setID] = useState();
  const [infoShow, setinfoShow] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [medType, setMedtype] = useState({ value: 'ModernMedicine', label: 'Modern medicine' });
  const [hasMore, setHasMore] = useState(true);
  const listRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchMedicines = (pageNum = page) => {
    setLoading(true);
    const tokenString = sessionStorage.getItem("usertoken");
    let v2 = tokenString.replace(/["]+/g, "");

    axios
      .get(
        `${APIURL}/api/v1/staff/medicine-search/V2/?search=${searchTermMed.trim()}&global=true&healthcare_type=${medType.value}&page=${pageNum}&per_page=${perPage}&${TZ}`,
        {
          headers: { Authorization: "Token " + v2 },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          if (res.data.status === 'success') {
            const datas = res.data.data ? res.data.data : res.data.message.medicines;

            if (pageNum === 1) {
              setFeatureList(datas);
            } else {
              setFeatureList(prevData => [...prevData, ...datas]);
            }

            const totalPagesCount = res.data.total_pages ? res.data.total_pages : res.data.message.total_pages;
            setTotalPages(totalPagesCount);
            setPage(pageNum);
            setTotalRows(res.data.total_records ? res.data.total_records : res.data.message.total_records);
            setHasMore(pageNum < totalPagesCount);
          } else {
            alert.error(res.data.message);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setPage(1);
    setFeatureList([]);
    fetchMedicines(1);
  }, [medType, searchTermMed, refresh, props.refresh]);

  const handleDeleteMed = () => {
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
    let dataToSend = {};

    if (action === "in_stock") {
      dataToSend = { in_stock: false };
    } else if (action === "out_stock") {
      dataToSend = { in_stock: true };
    } else if (action === "active") {
      dataToSend = { is_active: false };
    } else if (action === "inactive") {
      dataToSend = { is_active: true };
    }

    axios.put(`${APIURL}/api/v1/staff/master-medicine-detail/${id}/`, dataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: 'Token ' + str,
      }
    })
      .then(res => {
        if (res.data.status === "success") {
          alert.success(res.data.message);
          setFeatureList([]);
          setPage(1);
          fetchMedicines(1);
        } else {
          alert.error(res.data.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  const handleScroll = () => {
    if (listRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 200 && hasMore && !loading) {
        fetchMedicines(page + 1);
      }
    }
  };

  const handleSearchChange = (e) => {
    const filterValue = e.target.value;
    setSearchTermMed(filterValue);
    setFeatureList([]);
    setPage(1);
  };

  return (
    <>
      <LoadingOverlay
        active={loading}
        spinner
        styles={{
          spinner: (base) => ({
            ...base,
            width: "50px",
            "& svg circle": {
              stroke: "rgba(0, 0, 255, 0.5)",
            },
          }),
          overlay: {},
        }}
      >
        <div className="medicine-list-container">
          <div className="medicine-list-header">
            <div className="medicine-list-filters">
              <Select
                className="medicine-type-select"
                value={medType}
                onChange={(selectedOption) => {
                  setFeatureList([]);
                  setMedtype(selectedOption);
                }}
                options={[
                  { value: 'ModernMedicine', label: 'Modern medicine' },
                  { value: 'Unani', label: 'Unani medicine' }
                ]}
                name='med'
                classNamePrefix="select"
                styles={customSelectStyles}
              />

              <div className="medicine-search-container">
                <input
                  type="text"
                  className="medicine-search-input"
                  placeholder="Search medicine..."
                  value={searchTermMed}
                  onChange={handleSearchChange}
                />
                <svg className="medicine-search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
              </div>
            </div>

            <div className="medicine-list-stats">
              <span className="medicine-total-count">Total medicines: {totalRows}</span>
            </div>
          </div>

          <div className="medicine-list-scrollable" ref={listRef} onScroll={handleScroll}>
            {featureList.length > 0 ? (
              featureList.map((item, index) => (
                <div
                  key={item.id || index}
                  className={`medicine-list-item `}
                >
                  <div className="medicine-item-name">{item.med_name}</div>
                  <div className="medicine-item-actions">
                    {item.in_stock ? (
                      <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">in stock</Tooltip>}>
                        <svg
                          className="medicine-icon in-stock"
                          onClick={() => { setAction("in_stock"); setID(item.id); setMedConfirmModalShow(true) }}
                          xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M6 18h5.5v-4H6zm0-5h5.5V6H6zm6.5 5H18v-7h-5.5zm0-8H18V6h-5.5zM5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v2h2v2h-2v2h2v2h-2v2h2v2h-2v2q0 .825-.587 1.413T19 21zm0-2h14V5H5zM5 5v14z" />
                        </svg>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">out of stock</Tooltip>}>
                        <svg
                          className="medicine-icon out-stock"
                          onClick={() => { if (item.in_stock) { setAction("out_stock"); setID(item.id); setMedConfirmModalShow(true) } }}
                          xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M6.308 17.692h5.038v-3.538H6.308zm0-4.846h5.038V6.308H6.308zm6.346 4.846h5.038v-6.538h-5.038zm0-7.846h5.038V6.308h-5.038zM5.616 20q-.691 0-1.153-.462T4 18.384V5.616q0-.691.463-1.153T5.616 4h12.769q.69 0 1.153.463T20 5.616v2.153h1.539v1H20V11.5h1.539v1H20v2.73h1.539v1H20v2.155q0 .69-.462 1.152T18.384 20z" />
                        </svg>
                      </OverlayTrigger>
                    )}

                    {item.is_active ? (
                      <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Authorized</Tooltip>}>
                        <svg
                          className="medicine-icon active"
                          onClick={() => { setAction("active"); setID(item.id); setMedConfirmModalShow(true) }}
                          xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M16.5 6.5h-9C4.5 6.5 2 9 2 12s2.5 5.5 5.5 5.5h9c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5m0 8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5S19 10.6 19 12s-1.1 2.5-2.5 2.5" />
                        </svg>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Unauthorized</Tooltip>}>
                        <svg
                          className="medicine-icon inactive"
                          onClick={() => { if (item.is_active) { setAction("inactive"); setID(item.id); setMedConfirmModalShow(true) } }}
                          xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M7 17q-2.083 0-3.542-1.457T2 12.005T3.458 8.46Q4.917 7 7 7h10q2.083 0 3.542 1.457T22 11.995t-1.458 3.544Q19.083 17 17 17zm0-1h10q1.65 0 2.825-1.175T21 12t-1.175-2.825T17 8H7Q5.35 8 4.175 9.175T3 12t1.175 2.825T7 16m-.002-1.5q1.04 0 1.771-.728t.731-1.77t-.728-1.771t-1.77-.731t-1.771.729t-.731 1.769t.729 1.771t1.769.731M12 12" />
                        </svg>
                      </OverlayTrigger>
                    )}

                    <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">med interaction</Tooltip>}>
                      <svg
                        className={`medicine-icon med-interaction ${(item.med_interactions !== "null" && item.med_interactions !== "" && item.med_interactions !== null) ||
                          (item.med_url !== "null" && item.med_url !== "" && item.med_url !== null) ? 'has-data' : 'no-data'}`}
                        onClick={() => {
                          if ((item.med_interactions !== "null" && item.med_interactions !== "" && item.med_interactions !== null) ||
                            (item.med_url !== "null" && item.med_url !== "" && item.med_url !== null)) {
                            setInfoData1(item);
                            setdrugInt(true);
                            setinfoShow(true);
                          }
                        }}
                        xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3M12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z" />
                      </svg>
                    </OverlayTrigger>

                    <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Info</Tooltip>}>
                      <svg
                        className="medicine-icon info"
                        onClick={() => { setInfoData1(item); setdrugInt(false); setinfoShow(true); }}
                        xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 256 256">
                        <path fill="#FF9C01" d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m-4 48a12 12 0 1 1-12 12a12 12 0 0 1 12-12m12 112a16 16 0 0 1-16-16v-40a8 8 0 0 1 0-16a16 16 0 0 1 16 16v40a8 8 0 0 1 0 16" />
                      </svg>
                    </OverlayTrigger>

                    <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Edit</Tooltip>}>
                      <svg
                        className="medicine-icon medicine-icon-edit disabled"
                        xmlns="http://www.w3.org/2000/svg"
                        width="1.5em" height="1.5em" viewBox="0 0 24 24">
                        <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
                          <path d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352z" />
                          <path d="M19.846 4.318a2.2 2.2 0 0 0-.437-.692a2 2 0 0 0-.654-.463a1.92 1.92 0 0 0-1.544 0a2 2 0 0 0-.654.463l-.546.578l2.852 3.02l.546-.579a2.1 2.1 0 0 0 .437-.692a2.24 2.24 0 0 0 0-1.635M17.45 8.721L14.597 5.7L9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.5.5 0 0 0 .255-.145l4.778-5.06Z" />
                        </g>
                      </svg>
                    </OverlayTrigger>
                  </div>
                </div>
              ))
            ) : (
              <div className="medicine-empty-list">
                <p>No medicines found</p>
              </div>
            )}

            {loading && featureList.length > 0 && (
              <div className="medicine-loading-more">
                <div className="medicine-loading-spinner"></div>
                <span>Loading more...</span>
              </div>
            )}
          </div>
        </div>
      </LoadingOverlay>

      {infoShow && (
        <InfoPopup1
          show={infoShow}
          drugInt={drugInt}
          infoData1={infoData1}
          onHide={() => { setinfoShow(false); }}
        />
      )}

      {MedConfirmModalShow && (
        <DeleteMedConfirmPopup
          action={action}
          handleDelete={handleDeleteMed}
          onHide={() => setMedConfirmModalShow(false)}
        />
      )}
    </>
  );
}

export default PharmMedicine;
const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    // width: "250px",
    minHeight: '36px',
    height: '36px',
    fontSize: '14px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#d1d5db'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '36px',
    padding: '0 8px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
    paddingBottom: '0',
    paddingTop: '0',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '36px'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px'
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '4px'
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '14px',
    padding: '8px 12px'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px'
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '14px'
  })
};